import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'antd';

import { routeFileSelector } from '@/utilz';
import Button from '@/views/components/Buttons/Button';

export const PrintFooter = ({ handlePrint, details, generatePDF, setOpen }) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  return (
    <Row className="footer-section" justify="end">
      <Col>
        <Row gutter={20}>
          <Col>
            <Button onClick={() => (details ? generatePDF(details, false) : generatePDF())}>
              {t('translation:default.fields.downloadPDF')}
            </Button>
          </Col>
          <Col>
            <Button onClick={() => handlePrint()}>{t('translation:default.fields.print')}</Button>
          </Col>
          <Col>
            <Button variant="danger" onClick={() => setOpen(false)}>
              {t('translation:default.buttons.close')}
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
